import imageCompression from 'browser-image-compression';
import noty from '@lib/noty'

// Usage: 
// import compress from '@lib/compress';
// 
// PREREQUISITE: the package browser-image-compression must be installed in the main project.
// 
// Note: when a file is provided and the file is not compressible (not an image),
//       the original file is returned.
// 
// -- by default, max 1MB, max 1000px width: 
//     try {
//        const compressedFile = await compress.image(file);
//     } catch (error) {
//        noty.alert("Er trad een fout op bij het comprimeren van de afbeelding.");
//        console("compress.image - error", error);
//     }
// 
// -- compress a file to max  2MB, max 1920px width: 
//     try {    
//        const compressedFile = await compress.image(file, {maxSizeMB: 2, maxWidthOrHeight: 1920});
//     } catch (error) {
//        noty.alert("Er trad een fout op bij het comprimeren van de afbeelding.");
//        console("compress.image - error", error);
//     }
// 
var compress = {}; 

// Helper function private for this file. 
// Get the image dimensions. 
// Call this only when you know the file is an image. 
// 
// Use this method asynchronously!!! 
//
//  var dimensions = await imageDimensions(file);
// 
var imageDimensions = async (file) => {
    if (!file || !file.type || !file.type.startsWith('image/')) {
        return { width: 0, height: 0 };
    }

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function() {
            resolve({ width: img.width, height: img.height });
        };
        img.onerror = function() {
            reject("Failed to load image");
        };
        const reader = new FileReader();
        reader.onload = function(e) {
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
};

/**
 * Compress an image file.
 * @param {*} file The image file to compress
 * @param {*} options Options for the compression. See https://www.npmjs.com/package/browser-image-compression
 * @returns The compressed file. When the file is not an image, the original file
 *          is returned.
 * 
 * Note, use the try method if you don't want error handling yourself.
 */
compress.file = async (file, options) => {

    if (window.noCompression) {
        console.log("Skipping compression.");
        return file; 
    }

    options = options || {};
    if (undefined === options.maxWidthOrHeight) {
        options.maxWidthOrHeight = 1000;
    }
    if (undefined === options.maxSizeMB) {
        options.maxSizeMB = 1;
    }
    if (undefined === options.useWebWorker) {
        options.useWebWorker = false;
    }
    if (!file) {
        throw "No file specified";
    }
    if (!file.type) {
        throw "File type not specified";
    }
    if (!file.type.startsWith('image/')) {
        console.log("compress.file - not an image. Skipping", file);
        return file;
    }

    var dimensions = await imageDimensions(file);
    // When the image size is smaller than the max size, do not compress. 
    if (dimensions.width < options.maxWidthOrHeight && dimensions.height < options.maxWidthOrHeight) {
        console.log("compress.file - image dimensions within limits. No compression", dimensions);
        return file;
    }

    var sizeBefore = file.size;
    var compressedFile = await imageCompression(file, options);
    var sizeAfter = compressedFile.size;
    console.log(`Image compression ${sizeBefore} -> ${sizeAfter} bytes.`);
    // Convert Blob to File, to retain the original filename.
    if (compressedFile instanceof Blob) {
        const blobToFile = new File(
            [compressedFile],
            file.name,           // original filename
            { type: compressedFile.type }
        );
        compressedFile = blobToFile;
    }
    return compressedFile;
};

/**
 * try is the same as above except it catches errors, shows notifications and returns null on error.
 * 
 * @param {*} file 
 * @param {*} options 
 * @returns 
 */
compress.try = async (file, options) => {
    try {
        return await compress.file(file, options);

    } catch (error) {
        noty.alert("Er trad een fout op bij het comprimeren van het bestand.\n\nFoutdetails:" +error);
        console("compress - error", error);                    
    }
    return null;
};


export default compress;